import { ExcelValidationError, NoSheetExistsError } from "../utils/ExcelValidationError";
import { getRowsWithProperties, getUsedRangeWithProperties } from "../utils/excel";
import { Ptc } from "./ptcParser";

// Parse PTCs that should not be used for STH
export const parseSthExcludedPtcs = (
  worksheetName: string,
  allPtcs: Map<string, Ptc>,
  setLoadingText: (loadingText: string) => void
) => {
  return Excel.run(async (context) => {
    setLoadingText("Reading Excluded PTCs list...");

    const ptcsExcludedList = context.workbook.worksheets.getItemOrNullObject(worksheetName);
    await context.sync();

    if (ptcsExcludedList.isNullObject) {
      throw NoSheetExistsError(worksheetName);
    }

    const usedRange = await getUsedRangeWithProperties(context, ptcsExcludedList, ["rowCount", "columnCount"]);

    if (usedRange.columnCount === 0) {
      throw new ExcelValidationError("Sheet has no columns", worksheetName);
    }

    const ptcNamesToExclude: string[] = [];
    const rows = await getRowsWithProperties(usedRange, context, ["values"]);
    for (let i = 1; i < rows.length; i++) {
      const row = rows[i];

      const ptcName = row.values[0][0].toString().trim();
      if (!ptcName) {
        throw new ExcelValidationError("Empty cell", worksheetName, i + 1);
      }
      if (!allPtcs.has(ptcName)) {
        throw new ExcelValidationError(
          `${ptcName} is not a valid PTC (not found in PTC TDM sheet)`,
          worksheetName,
          i + 1
        );
      }

      ptcNamesToExclude.push(ptcName);
    }

    return ptcNamesToExclude;
  });
};
